<div class="layout-main">
  <div class="container-fluid">
    <div class="row">
      <div class="pb-2 mb-3 border-bottom col-12">
        <h2>
          <b>Encryption keys Logs</b>
        </h2>
      </div>
    </div>

    <div class=" row">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <p-panel [toggleable]="true">
              <ng-template pTemplate="header">
                <span class="filter-title p-panel-title"><i class="fa fa-search"></i> Filter</span>
              </ng-template>
              <div class="row">
                <div class="form-group col-6">
                  <div class="row">
                    <label class="col-2 m-auto">Company</label>
                    <div class="col-10">
                      <p-dropdown (onChange)="filter()"
                                  [(ngModel)]="encryptionKeysLogsFilterCriteria.company"
                                  [filter]="true"
                                  [options]="companyItems"
                                  [showClear]="true">
                      </p-dropdown>
                    </div>
                  </div>
                </div>
                <div class="form-group col-6">
                  <div class="row">
                    <label class="col-2 m-auto">User</label>
                    <div class="col-10">
                      <p-dropdown (onChange)="filter()"
                                  [(ngModel)]="encryptionKeysLogsFilterCriteria.user"

                                  [filter]="true"
                                  [options]="userItems"
                                  [showClear]="true">
                      </p-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row ">
                <div class="form-group col-6">
                  <div class="row ">
                    <label class="col-2 m-auto">Action</label>
                    <div class="col-10">
                      <select (change)="filter()" [(ngModel)]="encryptionKeysLogsFilterCriteria.action"
                              class="custom-select col-12">
                        <option *ngFor="let action of actionItems"
                                [attr.selected]="encryptionKeysLogsFilterCriteria.action == action.value ? true : null">{{ action.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-group col-6">
                  <div class="row">
                    <label class="control-label col-2 m-auto"> Date </label>
                    <div class="col-10">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">From</span>
                        <p-calendar (onSelect)="filter()" [(ngModel)]="encryptionKeysLogsFilterCriteria.dateFrom"
                                    dataType="string" dateFormat="mm/dd/yy">
                        </p-calendar>
                        <span class="p-inputgroup-addon" style="margin-left: 40px;">To</span>
                        <p-calendar (onSelect)="filter()" [(ngModel)]="encryptionKeysLogsFilterCriteria.dateTo"
                                    dataType="string" dateFormat="mm/dd/yy">
                        </p-calendar>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-11"></div>
                <div class="col-1">
                  <button (click)="reset()" icon="fa fa-refresh pr-2" iconPos="left" label="Reset" pButton
                          type="button"></button>
                </div>
              </div>
            </p-panel>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <div class="col-12" *ngIf="filteredEncryptionKeysLogs && filteredEncryptionKeysLogs.length > 0">
      <p-table (sortFunction)="tableService.customSort($event)" [columns]="columns" [customSort]="true"
               [paginator]="true" [rowHover]="true" [rows]="30"
               [tableStyle]="{'table-layout':'auto'}" [value]="filteredEncryptionKeysLogs"
               id="prod_encryption_keys_logs">
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of columns" [pSortableColumnDisabled]="col.sortDisabled"
                [pSortableColumn]="col.field">
              {{ col.header }}
              <p-sortIcon *ngIf="!col.sortDisabled" [field]="col.field" ariaLabel="Activate to sort"
                          ariaLabelAsc="Activate to sort in ascending order"
                          ariaLabelDesc="Activate to sort in descending order"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template let-key pTemplate="body">
          <tr>
            <td>{{ key.date | date : "MMM dd, y H:mm" }}</td>
            <td>{{ key.logDescription }}</td>
            <td>{{ key.action }}</td>
            <td>{{ getUserName(key) }}</td>
            <td>{{ key.companyName }}</td>
            <td>{{ key.method }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
